module.exports = __webpack_public_path__ + "img/wind.72f09c8f.png";